import { END_POINTS } from "../constants/urls";
import { CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

export const followersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserFollowers: builder.query<
      CommonResponseType & { data: any },
      {
        id: string;
      }
    >({
      query: ({ id }) => {
        return {
          url: `${END_POINTS.getUserFollowers}/${id}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useLazyGetUserFollowersQuery } = followersApi;
